/* eslint-disable import/export */
import { record, separated } from 'fp-ts';
import { pipe } from 'fp-ts/function';
export * from 'fp-ts/Record';
export { isNonEmpty } from './nonEmptyRecord.js';
export const indexBy = (f) => (as) => as.reduce((acc, current) => {
    acc[f(current)] = current;
    return acc;
}, {});
export const values = Object.values;
export const entries = Object.entries;
export const fromEntries = record.fromEntries;
export const collect = 
// eslint-disable-next-line @typescript-eslint/no-deprecated
record.collect;
/**
 * Determine if the given value is a JavaScript object (e.g. array, function, object, regex, etc.)
 */
export function isObject(value) {
    const type = typeof value;
    return value != null && (type === 'object' || type === 'function');
}
/**
 * Remove undefined values from an object
 */
export function removeUndefined(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([, v]) => typeof v !== 'undefined'));
}
/**
 * More generally typed version of {@link record.mapWithIndex}
 */
export const mapWithIndex = record.mapWithIndex;
/**
 * More generally typed version of {@link record.map}
 */
export const map = record.map;
/**
 * More generally typed version of {@link record.lookup}
 */
export const lookup = record.lookup;
/**
 * Copied from fp-ts-std
 *
 * Like `fp-ts/Record::lookup` but flipped, which the "V" suffix denotes.
 *
 * @example
 * import { lookupV } from 'fp-ts-std/Record'
 * import * as A from 'fp-ts/Array'
 *
 * const x = { a: 1, b: 'two', c: [true] }
 * const ks = ['a', 'c']
 *
 * assert.deepStrictEqual(A.filterMap(lookupV(x))(ks), [1, [true]])
 */
export const lookupV = (r) => (k) => pipe(r, lookup(k));
/**
 * More generally typed version of {@link record.filterMap}
 */
export const filterMap = record.filterMap;
/**
 * More generally typed version of {@link record.filterMapWithIndex}
 */
export const filterMapWithIndex = record.filterMapWithIndex;
/**
 * Transform a record of Separated instances into a Separated instance of records.
 */
export const sequenceSeparated = (r) => separated.separated(pipe(r, map(separated.left)), pipe(r, map(separated.right)));
/**
 * More generally typed version of {@link record.compact}
 */
export const compact = record.compact;
export const size = record.size;
export const partitionMap = record.partitionMap;
export const traverseWithIndex = record.traverseWithIndex;
//# sourceMappingURL=record.js.map